import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { LogoFull } from "./Logo";
import { SITE } from "@/lib/site";
import { SERVICES } from "@/lib/services";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-ink text-paper border-t border-ink-line">
    <div className="mx-auto max-w-[1400px] px-5 pt-20 pb-28 sm:px-8 lg:pb-10">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <LogoFull light className="w-56" />
          <p className="mt-6 max-w-xs text-sm text-paper/75 leading-relaxed">Artisan peintre professionnel à {SITE.city} et ses alentours. Peinture, décoration, ravalement et revêtements.</p>
          <div className="mt-8 space-y-3 text-sm">
            <a href={SITE.phoneHref} className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-phone"><Phone className="h-4 w-4 text-gold" />{SITE.phone}</a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-email"><Mail className="h-4 w-4 text-gold" />{SITE.email}</a>
            <p className="flex items-center gap-3 text-paper/85"><MapPin className="h-4 w-4 text-gold" />{SITE.address}</p>
          </div>
          <div className="mt-8">
            <h4 className="eyebrow text-gold mb-4">Suivez-nous</h4>
            <div className="flex gap-3" data-testid="footer-socials">
              {SITE.socials.map((s) => {
                const Icon = s.name === "Instagram" ? Instagram : Facebook;
                return (
                  <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={`${s.name} — ${s.handle}`} title={s.handle}
                    data-testid={`footer-social-${s.name.toLowerCase()}`}
                    className="group flex h-11 w-11 items-center justify-center border border-ink-line text-paper/80 transition-[background-color,color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold hover:bg-gold hover:text-ink">
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
        <div className="lg:col-span-2">
          <h4 className="eyebrow text-gold mb-5">Services</h4>
          <ul className="space-y-3 text-sm">
            {SERVICES.map((s) => <li key={s.slug}><Link to={`/services/${s.slug}`} className="link-line text-paper/85" data-testid={`footer-service-${s.slug}`}>{s.title}</Link></li>)}
            <li><Link to="/devis" className="link-line text-paper/85" data-testid="footer-devis">Devis gratuit</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <h4 className="eyebrow text-gold mb-5">Horaires</h4>
          <ul className="space-y-3 text-sm" data-testid="footer-hours">
            {SITE.hours.map(([d, h]) => <li key={d}><span className="block text-paper/60 text-xs">{d}</span>{h}</li>)}
          </ul>
        </div>
        <div className="lg:col-span-4">
          <h4 className="eyebrow text-gold mb-5">Communes desservies</h4>
          <ul className="flex flex-wrap gap-x-4 gap-y-2 text-sm text-paper/80" data-testid="footer-communes">
            {SITE.communes.map((c) => <li key={c}>Peintre {c}</li>)}
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="mt-20 select-none font-display text-[15vw] leading-[0.8] tracking-[-0.04em] text-paper/[0.06] whitespace-nowrap overflow-hidden">Style Peinture</p>
      <div className="mt-6 flex flex-col gap-4 border-t border-ink-line pt-6 text-xs text-paper/65 sm:flex-row sm:justify-between">
        <p>© {new Date().getFullYear()} {SITE.name} · {SITE.siret}</p>
        <div className="flex gap-6">
          <Link to="/mentions-legales" className="link-line" data-testid="footer-legal-link">Mentions légales</Link>
          <Link to="/mentions-legales#confidentialite" className="link-line" data-testid="footer-privacy-link">Confidentialité</Link>
          <Link to="/admin" className="link-line" data-testid="footer-admin-link">Espace pro</Link>
        </div>
      </div>
    </div>
  </footer>
);

export const MobileBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-ink-line bg-ink lg:hidden" data-testid="mobile-cta-bar">
    <a href={SITE.phoneHref} className="flex items-center justify-center gap-2 py-4 text-sm font-semibold text-paper" data-testid="mobile-bar-call"><Phone className="h-4 w-4 text-gold" />Appeler</a>
    <Link to="/devis" className="bg-gold py-4 text-center text-sm font-semibold text-ink" data-testid="mobile-bar-devis">Devis Gratuit</Link>
  </div>
);
